import { Link } from "react-router-dom";
import { Instagram, MapPin, Phone, Navigation, Mail, Star } from "lucide-react";
import { SITE, EXPERIENCE_LINKS, telLink } from "@/data/site";

const FOOTER_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Stay", to: "/stay" },
  ...EXPERIENCE_LINKS,
  { label: "Gallery", to: "/gallery" },
  { label: "Reviews", to: "/reviews" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-forest text-ivory">
      <div className="mx-auto max-w-[1400px] px-5 py-14 md:px-10">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <img src={SITE.logo} alt="Vruksha Valley Eco Resort" className="h-14 w-auto md:h-16" />
            <p className="mt-6 max-w-sm text-ivory/70">
              A cinematic, eco-luxury nature retreat in the mist of the Western Ghats, near Kalasa — set within a coffee estate with authentic Malnad hospitality.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="mb-5 text-xs uppercase tracking-widest-2 text-ivory/50">Explore</p>
            <ul className="space-y-3">
              {FOOTER_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-ivory/80 transition-colors hover:text-gold">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="mb-5 text-xs uppercase tracking-widest-2 text-ivory/50">Reach Us</p>
            <ul className="space-y-4 text-ivory/80">
              <li className="flex gap-3">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
                <span>{SITE.address}<br /><span className="text-ivory/50">{SITE.plusCode}</span></span>
              </li>
              <li>
                <a href={telLink} className="flex items-center gap-3 hover:text-gold">
                  <Phone className="h-5 w-5 text-gold" /> {SITE.phone}
                </a>
              </li>
              <li>
                <a href={`tel:${SITE.phone2Intl}`} className="flex items-center gap-3 hover:text-gold">
                  <Phone className="h-5 w-5 text-gold" /> {SITE.phone2}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 hover:text-gold">
                  <Mail className="h-5 w-5 text-gold" /> {SITE.email}
                </a>
              </li>
              <li>
                <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-gold">
                  <Instagram className="h-5 w-5 text-gold" /> @vrukshavalley
                </a>
              </li>
              <li>
                <a href={SITE.googleReviews} target="_blank" rel="noopener noreferrer" data-testid="footer-google-reviews" className="flex items-center gap-3 hover:text-gold">
                  <Star className="h-5 w-5 text-gold" /> Read Our Google Reviews
                </a>
              </li>
              <li>
                <a href={SITE.mapUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-gold">
                  <Navigation className="h-5 w-5 text-gold" /> Get Directions
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-ivory/15 pt-8 text-sm text-ivory/50 md:flex-row">
          <p>© {new Date().getFullYear()} Vruksha Valley Eco Resort. All rights reserved.</p>
          <p>
            Made by Sunil ·{" "}
            <a href={SITE.agency} target="_blank" rel="noopener noreferrer" data-testid="footer-agency-link" className="text-gold hover:underline">
              Smart Marketing Chikmagalur
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
